import { Typography } from "@material-ui/core";
import { AditamentoDiferenca } from "./aditamentoRevisionModal";
import { ArrayChangesComparisonTable } from "./arrayChangesComparisonTable";
import { FieldGroupAditamento } from "./aditamentoRevisionModal";

export const SpecializedArrayRenderer: React.FC<{
    group: FieldGroupAditamento;
    canEdit: boolean;
    onFieldValueChange: (path: string, value: string) => void;
    onDifferencesUpdate?: (updatedDifferences: AditamentoDiferenca[]) => void;
    allDifferences: AditamentoDiferenca[];
    classes: any;
}> = ({ group, canEdit, onFieldValueChange, onDifferencesUpdate, allDifferences, classes }) => {
    if (!group.arrayType || group.arrayType === 'generic') {
        return null;
    }

    const getTitle = () => {
        switch (group.arrayType) {
            case 'amortizacoes':
                return 'Amortizações';
            case 'pagamentojuros':
                return 'Pagamento de Juros';
            case 'incorporacaojuros':
                return 'Incorporação de Juros';
            default:
                return group.groupName;
        }
    };

    const arrayDifference = group.fields[0];

    if (!arrayDifference) {
        return (
            <Typography variant="body2" color="textSecondary" style={{ padding: 16 }}>
                Nenhum dado de array encontrado.
            </Typography>
        );
    }

    const handleArrayUpdate = (updatedArrayDiff: AditamentoDiferenca) => {
        if (onDifferencesUpdate) {
            const updatedDifferences = allDifferences.map(diff =>
                diff.caminhoCompleto === arrayDifference.caminhoCompleto ? updatedArrayDiff : diff
            );

            onDifferencesUpdate(updatedDifferences);
        }
    };

    return (
        <ArrayChangesComparisonTable
            title={getTitle()}
            arrayType={group.arrayType}
            arrayDifference={arrayDifference}
            onArrayUpdate={handleArrayUpdate}
            canEdit={canEdit}
        />
    );
};